function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6371 7.33691L12.9083 7.40809C13.0446 8.49748 12.7528 9.61111 12.0865 10.5439C11.4111 11.4895 10.3769 12.2063 9.17442 12.5622C8.59877 12.7325 8.00742 12.8141 7.42173 12.8141C5.73108 12.814 4.09031 12.1335 3.02999 10.9441H3.75597V10.2962H1.79541V12.1084H2.52867V11.426C3.22787 12.1782 4.15452 12.7648 5.2066 13.1108C5.91751 13.3447 6.66745 13.4619 7.41643 13.4619C8.09056 13.4619 8.76398 13.3669 9.4073 13.1765C10.7695 12.7734 11.9412 11.9612 12.7066 10.8897C13.4611 9.83331 13.7916 8.57159 13.6371 7.33691V7.33691Z",
  fill: "#0D5AE5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.37367 4.98623C4.05612 4.03535 5.11039 3.3157 6.34226 2.95983C7.54189 2.61333 8.80387 2.62433 9.99188 2.99175C10.9196 3.27868 11.7467 3.7768 12.3776 4.42035L11.6715 4.42014L11.6713 5.05908L13.6743 5.05966V3.35247H12.9334V3.99787C12.2199 3.27396 11.2873 2.71361 10.242 2.3903C8.89585 1.974 7.36707 1.99775 6.00809 2.3903C4.61255 2.79342 3.517 3.57249 2.74368 4.64995C1.98042 5.7134 1.66186 6.97839 1.84666 8.21191L2.58146 8.13004C2.41841 7.04169 2.69975 5.9252 3.37367 4.98623Z",
  fill: "#0D5AE5"
});

var SvgExchangeIcon = function SvgExchangeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExchangeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/exchange_icon.2b0d1f21.svg";
export { ForwardRef as ReactComponent };